import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { StickyContainer } from 'react-sticky'
import _ from 'lodash'
import Tray from '../Tray/Video'
import Overlay from '~/components/Overlay'
import popup from '~/views/Popup/popup'
import ListItem from '~/components/ListItem'
import ShowTrailerInfo from './show-trailer-info'
import SeasonListDropdownView from './season-list-dropdown-view'
import SeasonListTabularView from './season-list-tabular-view'
import FeaturedEpisodeInfo from './featured-episode-info'
import Modal from '~/components/Modal'
import VideoJSPlayer from '~/components/VideoPlayer'
import share from '~/tools/share'
import { isSite } from '~/tools/isSite'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { getUser } from '~/redux/user/helpers'
import { getTransactionInfo, getVideoInfo, addToQueue, removeFromQueue, getVideoData } from '~/redux/uservideo/helpers'
import { fetchModels } from '~/redux/models/helpers'
import definePricingMap from '~/tools/definePricingMap'
import appendVideoData from '~/tools/appendVideoData'
import Sharing from '~/components/Sharing'
import filterCredits from "~/tools/filterCreditBlocks";
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import './styles.css'

class ShowPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deviceType: 'desktop',
      trailerModalOpen: false,
      previewSettings: _.get(window.settings, 'features.free_preview'),
      currentEpisode: 1,
      currentSeason: this.props.data.contentData[0].seasons.length - 1,
      seasonInfo: _.get(props, 'data.contentData[0].seasons'),
      seriesInfo: _.get(this.props, 'data.contentData[0].gist'),
      hashMap: {},
    }
    this.updatedShowData = _.cloneDeep(this.props.data.contentData[0])
  }

  async componentDidMount() {
    const scrollTo = this.episodesTray ? (this.episodesTray.offsetTop - (this.state.topOffset + 50)) : 0
    this.setState({ scrollTo: scrollTo, model: await fetchModels() })
    this.handleResize()
    this.getVideoInfo()
    this.defineHashMap()
    this.getTransactionInfo()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth < 600) {
      this.setState({
        topOffset: 53,
        deviceType: 'mobile'
      })
    } else if ((window.innerWidth > 600 && window.innerWidth < 1024)) {
      this.setState({
        topOffset: 53,
        deviceType: 'tablet'
      })
    } else {
      this.setState({
        topOffset: 67,
        deviceType: 'desktop'
      })
    }
  }

  createSeasonPass = (seasonId) => {
    return {
      contentType: 'SEASON_PASS',
      gist: {
        id: seasonId,
        title: 'Season Pass',
        background: '#000',
        cta: isSite('bingeflix') ? 'Purchase' : 'Purchase Season',
        permalink: 'TBD',
      }
    }
  }

  defineHashMap = () => {
    const showData = this.updatedShowData
    const currentSeasons = showData.seasons
    let { hashMap } = this.state
    hashMap.totalEps = 0

    currentSeasons.forEach(season => {
      const seasonId = season.id
      if (!hashMap[seasonId]) hashMap[seasonId] = { season: season, episodes: {} }
      season.episodes.forEach(episode => {
        const episodeId = episode.gist.id
        hashMap.totalEps++
        if (!hashMap[seasonId].episodes[episodeId]) {
          hashMap[seasonId].episodes[episodeId] = episode
        }
      })

      if (season.pricing) {
        season.episodes.unshift(this.createSeasonPass(seasonId))
        season.seasonPass = true
      }

      if (showData.pricing && showData.pricing.purchase) {
        showData.isSeriesPurchable = true
      }
    })
    this.setState({ hashMap })
  }

  appendPurchaseStatus = () => {
    let { purchasedSeasonsInfo, hashMap } = this.state
    let totalEpsPurchased = 0

    if (purchasedSeasonsInfo) {
      purchasedSeasonsInfo.forEach(season => {
        const purchasedSeasonId = season.seasonId
        const purchasedEpisodes = season.videos
        purchasedEpisodes.forEach(episode => {
          totalEpsPurchased++
          const purchasedEpisode = hashMap[purchasedSeasonId].episodes[episode.gist.id]
          _.assign(purchasedEpisode, { purchaseStatus: 'PURCHASED' })
        })

        const purchasedSeason = hashMap[purchasedSeasonId].season
        if (purchasedSeason.pricing && purchasedSeason.seasonPass &&
          purchasedEpisodes.length === purchasedSeason.episodes.length - 1) {
          purchasedSeason.episodes.shift()
          purchasedSeason.seasonPass = false
        }
      })

      if (hashMap.totalEps === totalEpsPurchased) {
        this.updatedShowData.isSeriesPurchable = false
      }
    }

    this.setState({ hashMap })
  }

  getTransactionInfo = () => {
    const id = _.get(this.props, 'data.contentData[0].id')
    const user = _.get(this.state.user, 'userId')
    if (!user) return
    getTransactionInfo(user, true, 'SERIES', id).then(res => {
      if (res.data) {
        this.setState({ purchasedSeasonsInfo: res.data.seasons })
        this.appendPurchaseStatus()
      }
    })
  }

  getVideoInfo = () => {
    const id = _.get(this.props.data, 'contentData[0].gist.id')
    getUser(user => {
      if (!user) {
        return
      }
      getVideoInfo(id, data => {
        this.setState({
          isQueued: data.isQueued,
          startTime: data.watchedTime,
        })
      })
    })
  }

  toggleTrailerModal = () => {
    this.setState({ trailerModalOpen: !this.state.trailerModalOpen })
    window.document.body.classList.toggle('overflow-hide')
  }

  playEpisode = (index) => {
    const showData = this.updatedShowData
    const currentSeason = showData.seasons[this.state.currentSeason]
    const episode = currentSeason.episodes[index]
    this.getFilmSrc(episode.gist, this.state.currentSeason, index, true)
  }

  openEpisodeOverlay = (e, index, season, item) => {
    if (e) e.preventDefault()
    const showData = this.updatedShowData 
    const currentSeason = showData.seasons[season]
    const ids = { series: showData.id, season: currentSeason.id }
    const preview = this.state.previewSettings
    const video = currentSeason.episodes[index] && currentSeason.episodes[index].gist;


    if (item) {
      var contentType = _.get(item, 'contentType') || _.get(item, 'gist.contentType')
      var pricingType = item.pricing && item.pricing.type
      var hasAccess = definePricingMap(this.state, item, this.state.model)
    }

    const checkVideoAccess = !hasAccess && (preview && !preview.isFreePreview) && pricingType 
    && (pricingType !== 'FREE' || !item.gist.isTrailer) && pricingType !== 'SVOD'

    if (contentType && contentType === 'SEASON_PASS') {
      const eps = _.reduce(currentSeason.episodes, (arr, e) => {
        arr.push(e.gist.id)
        return arr
      }, [])
      const seasonIds = {
        ...ids,
        content: currentSeason.id,
        items: eps
      }
      const itemTitle = isSite('bingeflix') ? 'Program' : 'Season Pass'
      const items = Overlay.formatPricing(currentSeason.pricing, seasonIds, itemTitle)
      const content = { 
        gist: { 
          ...currentSeason,
          contentType: 'SEASON',
          title: currentSeason.title + '\'s Season Pass'
        }
      }
      if(isSite('bingeflix')) content.gist.title = 'This program'
      popup.purchase(items[0], content, () => this.playEpisode(1))
    } else if ((contentType && contentType === 'VIDEO') && checkVideoAccess) {
      const videoIds = {  
        ...ids,
        content: item.gist.id,
        video: item.gist.id
      }
      const items = Overlay.formatPricing(item.pricing, videoIds, item.gist.title) 
      const content = {
        gist: {
          ...currentSeason,
          contentType: 'EPISODE',
          title: item.gist.title
        }
      }
      popup.purchase(items[0], content, () => this.playEpisode(index, currentSeason.id))
    } else if (contentType && contentType === 'SERIES') {
      const videoIds = {  
        content: item.gist.id,
      }
      const items = Overlay.formatPricing(item.pricing, videoIds, item.gist.title) 
      const content = {
        gist: {
          contentType: 'SERIES',
          title: item.gist.title
        }
      }
      popup.purchase(items[0], content, () => this.playEpisode(index, currentSeason.id))
    } else {
      this.getFilmSrc(video, season, index)
    }
  }

  handleChange = (e, selectedIndex) => {
    if (selectedIndex === undefined) {
      selectedIndex = e.target.value
    }
    this.setState({
      currentSeason: selectedIndex,
    })
  }

  renderMobileItems = () => {
    return (
      <ListItem
        isEpisode={true}
        openEpisodeOverlay={this.openEpisodeOverlay}
        items={_.map(this.updatedShowData.seasons[this.state.currentSeason].episodes, item => (
          { ...item.gist, pricing: item.pricing, purchaseStatus: item.purchaseStatus, container: item }
        ))}
        season={this.state.currentSeason}
      />
    )
  }

  toggleQueue = () => {
    if (!this.state.user) popup.login();

    const { gist = {} } = this.updatedShowData;
    const id = gist.id;
    const contentType = gist.contentType;

    if (this.state.isQueued) {
      removeFromQueue(id, data => {
        const videoEventData = appendVideoData(this.updatedShowData)
        trackEvent("Removed From Watchlist", videoEventData);
        this.setState({ isQueued: false });
      })
    } else {
      addToQueue(id, contentType, data => {
        const videoEventData = appendVideoData(this.updatedShowData)
        trackEvent("Added to Watchlist", videoEventData);
        this.setState({ isQueued: true });
      });
    }
  }

  renderShareContainer = () => {
    const { user, isQueued } = this.state
    return (
      <div className='show__share'>
        <Sharing 
          socialShare={this.socialShare} 
          toggleQueue={this.toggleQueue}
          user={user}
          isQueued={isQueued}
        />
      </div>
    )
  }

  socialShare = (platform) => {
    const { gist = {} } = this.updatedShowData;
    const videoEventData = appendVideoData(this.updatedShowData)
    videoEventData.medium = platform;
    switch (platform) {
      case "Facebook":
        share.facebook(window.location.href);
        break;
      case "Twitter":
        share.twitter(window.location.href, gist.title);
        break;
      case "Email":
        share.email(window.location.href);
        break;
      default:
        break;
    }
    trackEvent("Shared", videoEventData);
  }

  getFilmSrc = (videoInfo, season, episode, purchased) => {
    if(!videoInfo)
    {
      return;
    }
    const showData = this.updatedShowData
    const pricingOptions = _.get(showData, `seasons[${season}].episodes[${episode}].pricing`);
    const videoId = videoInfo.id;
    const watchedTime = videoInfo.watchHistory ? videoInfo.watchHistory.watchedTime : 0;
    getVideoData(videoId, res => {
      let video = res
      const { seriesInfo } = this.state
      video = {
        ...video,
        purchasedFlag: purchased,
        currentSeason: season,
        currentEpisode: episode,
        showData: showData,
        fileType: _.get(this.props.data, 'metadataMap.fileType'),
        watchedTime: watchedTime,
        seasonTitle: videoInfo.seasonTitle,
        episodeNumber: videoInfo.episodeNumber,
        title: showData.seasons[season].episodes[episode].gist.title,
        nextEpisode: this.getNextEpisode(season, episode),
        openPurchaseScreen:  e => this.openEpisodeOverlay(e, episode, season, video),
        playNextEpisode: e => {
          const nextEpisode = video.nextEpisode
          const episodeIndex = nextEpisode.gist.episodeNumber - 1
          const seasonIndex = nextEpisode.gist.seasonNumber
          return this.openEpisodeOverlay(e, episodeIndex, seasonIndex, nextEpisode)
        }
      }
      popup.episodeOverlay({ video, pricingOptions, seriesInfo })
    })
  }

  getNextEpisode(seasonIndex, episodeIndex) {
    const show = this.updatedShowData;
    const season = show.seasons[seasonIndex];

    let nextEpisode;

    //In the season
    if(season.episodes[episodeIndex+1]){
      nextEpisode = season.episodes[episodeIndex+1];
    }

    //In the series
    else if(show.seasons[seasonIndex+1] && show.seasons[seasonIndex+1].episodes[0]){
      nextEpisode = show.seasons[seasonIndex+1].episodes[0];
    }

    //Or the first episode
    else{
      nextEpisode = show.seasons[0].episodes[0];
    }

    return nextEpisode;
  }

  getFeaturedEpisode(show){

    let featuredEpisode;

    show.seasons.forEach( (season, n) => {
      season.episodes.forEach( (episode, i) => {

        if(episode.gist.watchHistory && episode.gist.watchHistory.latestEpisode){
          //If episode watched, get next episode
          if(episode.gist.watchHistory.watchedPercentage > 90){
            featuredEpisode = this.getNextEpisode(n,i);            
          }
          //Current episode
          else{
          featuredEpisode = episode;
          }
        }
      });
    });

    //If no watch history, get first episode
    if(featuredEpisode == null){
      for(let episode of show.seasons[0].episodes) {
        if(episode.gist.episodeNumber != undefined){
          featuredEpisode = episode;
          break;
        }
      }
    }
    
    return featuredEpisode;
  }

  renderSeasonList = () => {
    const moduleSettings = this.props.data.settings
    const seasonNames = _.map(this.updatedShowData.seasons, season => _.trim(season.title)).reverse()
    const tabularView = moduleSettings.tabularView || true
    const columns = this.props.layout.settings.columns || {
      desktop: 6,
      mobile: 2,
      ott: 6,
      tablet: 4,
    }
    if (tabularView) {
      return (
        <SeasonListTabularView
          scrollTo={this.state.scrollTo}
          deviceType={this.state.deviceType}
          columns={columns}
          handleChange={this.handleChange}
          seasonNames={seasonNames}
          currentSeason={this.state.currentSeason}
        />
      )
    } else {
      return (
        <SeasonListDropdownView
          handleChange={this.handleChange}
          seasonNames={seasonNames}
          currentSeason={this.state.currentSeason}
        />
      )
    }
  }

  renderHelmet = (gist) => {
    return (
      <Helmet>
        <title>{`${gist.title} | ${window.settings.site}`}</title>
        <meta name="description" content={gist.description} />
        <meta property="og:type" content="video.tv_show" />
        <meta property="og:title" content={gist.title} />
        <meta property="og:description" content={gist.description} />
        <meta property="og:image" content={gist.videoImageUrl} />
      </Helmet>
    )
  }

  renderHeroImage = (showData) => {
    const imageCenter = _.get(this.props.data, 'metadataMap.imageCenterMode');
    const heroImageUrl = _.get(showData, 'images._32x9Image.url') || _.get(showData, 'images._16x9Image.url');
    const trailerSrc = _.get(showData, "showDetails.trailers[0]");
    if (trailerSrc) trailerSrc.videoId = trailerSrc.id;
    return (
      <div className={imageCenter && imageCenter === 'true' && 'center'}>
        <div 
          className="show__hero"
          style={{ cursor: trailerSrc ? 'pointer' : 'auto' }}
          onClick={ trailerSrc ?  this.toggleTrailerModal : null }
        >
          <img className="show__hero__image" src={`${heroImageUrl}?impolicy=resize&h=900&w=1600`} alt="show banner" />
          {trailerSrc && (
            <div className="show__play__icon site-color">
              <i className="ion-ios-play" />
            </div>
          )}
        </div>
      </div>
    )
  }

  renderDetailsBar = (showData, gist) => {
    let firstSeasonEpisodes = _.size(_.get(showData, "seasons[0].episodes"));
    let label = isSite('bingeflix') ? 'Program' : 'Episode'
    if (showData.seasons[0].hasSeasonPass) firstSeasonEpisodes = firstSeasonEpisodes - 1
    const metadata = showData.seasons.length > 1 ? `${showData.seasons.length} Seasons ` : (firstSeasonEpisodes > 1 ? `${firstSeasonEpisodes} ${label}s` : `${firstSeasonEpisodes} ${label}`);
    return (
      <div className="show__details">
        <div className="show__title__box">
          <span className="title">{gist.title}</span>
          <span className="meta-data">
            {metadata}
            {(gist.primaryCategory && gist.primaryCategory.title) && ` |  ${_.get(gist, 'primaryCategory.title')}`}
          </span>
        </div>
        <div className="desktop-share">{this.renderShareContainer(gist.title)}</div>
      </div>
    )
  }

  renderShowDetails = (showData) => {
    const { description } = showData.gist;
    const trailerSrc = _.get(showData, "showDetails.trailers[0]");
    if (trailerSrc) trailerSrc.videoId = trailerSrc.id;
    const creditBlocks = filterCredits(showData.creditBlocks)
    const featuredEpisode = this.getFeaturedEpisode(showData);
    const featuredSeason = featuredEpisode.gist.seasonNumber
    return (  
      <div className="show__info">
        <div className="show__trailer__box">
          <ShowTrailerInfo
            trailerSrc={trailerSrc}
            description={description}
            creditBlocks={creditBlocks}
          />
        </div>
        {
          featuredEpisode !== null &&
          (
            <div className="show__next__episode">
              <FeaturedEpisodeInfo
                showData={showData}
                seriesPurchaseStatus={showData.isSeriesPurchable}
                episodeDetails={featuredEpisode}
                openEpisodeOverlay={this.openEpisodeOverlay}
                seasonPass={showData.seasons[featuredSeason].hasSeasonPass}
              />
            </div>
          )
        }
      </div>
    )
  }

  renderSeasonsAndEpisodesTray = (showData) => {
    const totalSeasons = showData.seasons.length;
    const totalEpisodesInFirstSeason = totalSeasons ? showData.seasons[0].episodes.length : 0;
    const layout = { settings: { infoHover: false, thumbnailType: "landscape", loop: false, columns: { desktop: 6, mobile: 3, ott: 6, tablet: 4 } } };
    return totalSeasons > 0 && totalEpisodesInFirstSeason > 0 &&
      (
        <StickyContainer>
          <div className="episodes-tray-container" ref={elem => (this.episodesTray = elem)}>
            <div className="season-list-container">
              <div className="seasons-list">
                {this.renderSeasonList()}
              </div>
            </div>
            <div className="episodes-tray">
              <Tray
                trayTitle='Tray'
                data={{
                  contentData: this.updatedShowData.seasons[this.state.currentSeason].episodes,
                  isEpisode: true
                }}
                layout={layout}
                openEpisodeOverlay={this.openEpisodeOverlay}
                lazyLoad={false}
                season={this.state.currentSeason}
              />
              <div className="mobile-display">{this.renderMobileItems()}</div>
            </div>
          </div>
        </StickyContainer>
      )
  }

  renderTrailerModal = (showData) => {
    const trailerSrc = _.get(showData, 'showDetails.trailers[0]');
    if (trailerSrc) trailerSrc.videoId = trailerSrc.id;
    return (trailerSrc && this.state.trailerModalOpen) && (
      <Modal
        title={trailerSrc.title}
        shown={this.state.trailerModalOpen}
        closeModal={this.toggleTrailerModal}
        className="modal-anim"
        children={
          <VideoJSPlayer
            {...trailerSrc}
            autoplay={true}
            isTrailer={true}
            fileType={this.props.data.metadataMap.fileType}
            modalOpen={this.state.trailerModalOpen}
          />
        }
      />
    )
  }

  render() {
    const showData = this.updatedShowData 
    const { gist } = showData
    return (
      <div className="show">
        { this.renderHelmet(gist) }
        { this.renderHeroImage(showData) }
        { this.renderDetailsBar(showData, gist) }
        { this.renderShowDetails(showData) }
        <div className="mobile-share">
          { this.renderShareContainer(gist.title) }
        </div>
        { this.renderSeasonsAndEpisodesTray(showData) }
        { this.renderTrailerModal(showData) }
      </div>
    )
  }
}

connect(ShowPage, state => ({ user: state.user }), userStore)


export default ShowPage;
